import { gql } from '__generated__';

gql(`
  fragment MailPermissionAttributes on MailPermission {
    id
    title
    label
    interest_list_event {
      id
      title
    }
    events {
      id
      title
    }
    soft_opt_in
    opt_in_count
    opt_out_count
    translations {
      ...TranslationFields
    }
    integration {
      id
      type
    }
    integration_config {
      mailchimp {
        audience_id
      }
      active_campaign {
        list_id
      }
    }
  }
`);

export default gql(`
  query GetMailPermissions($id: ID!) {
    project(id: $id) {
      id
      mail_permissions {
        ...MailPermissionAttributes
      }
    }
  }
`);
